/**
 * Faq — a list of question/answer pairs rendered as a collapsible accordion.
 * Composes the Accordion primitive. Answers support inline markdown via Prose.
 * Tokens + Tailwind only.
 */
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../accordion';
import { Prose } from './Prose';

export interface FaqEntry {
  readonly question: string;
  readonly answer: string;
}

export interface FaqProps {
  readonly items: readonly FaqEntry[];
}

export function Faq({ items }: FaqProps) {
  return (
    <Accordion type="single" collapsible className="w-full">
      {items.map((item, i) => (
        <AccordionItem key={i} value={`faq-${i}`}>
          <AccordionTrigger className="text-left text-base font-medium text-foreground">
            {item.question}
          </AccordionTrigger>
          <AccordionContent>
            <Prose content={item.answer} />
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
